import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  componentHeight: 0,
  mainView: "Sell",
};

const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    changeComponentHeight: (state, action) => {
      state.componentHeight = action.payload;
    },
    changeMainView: (state, action) => {
      // if (state.mainView === "Sell") {
      //   state.mainView = "request";
      // }else {
      //   state.mainView = "Sell";
      // }
      state.mainView = action.payload;
    }
  },
});

export default generalSlice.reducer;
export const { changeComponentHeight, changeMainView } = generalSlice.actions;